<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="12">
        <span style="font-size:18px;">库位信息 </span>

        <b-button
          v-allow="'actAdd'"
          size="sm"
          class="ml-2"
          variant="outline-success"
          @click="$emit('addTop')"
        >
          <b-icon-plus></b-icon-plus>新增
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
// 初始表单

export default {
  data() {
    return {
      form: {},
    }
  },
  created() {
    this.query()
  },
  methods: {
    fromLoad(val) {
      this.$emit(val)
    },
    // 初始查询
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', this.form)
    },
    // 重置查询条件 - 高级查询
    reset() {
      this.form = {}
    },
  },
}
</script>
